module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/绿色制造-text.5aa11ddf.png";